import { BigNumber } from 'bignumber.js';

export const moneyFormat = (amount: BigNumber | string | number): string => {
  return `$${new BigNumber(amount).toFormat(2)}`;
};
